import React, { Component } from "react";
import "./CreateOpportunityDocument.css";
import FormGenerator from "tools/components/v1/FormGenerator/FormGenerator";
import Fields from "tools/components/v1/FormGenerator/Fields";
import ApiCallHandler from "shared/js/ApiCallHandler";
import URLS from "shared/js/urls";
import { connect } from "react-redux";
import {
  toggleToastAction,
  editMutationAction,
} from "store/actions/actions";
import { bindActionCreators } from "redux";
import { isEmpty } from '../../../../../shared/js/utils';

class CreateOpportunityDocument extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showToast: false,
    };
  }
  updateReduxWithResponseData = (editMode, res) => {
    let { currentInvestment } = this.props;
    let documents = currentInvestment?.documents;
    if (!editMode) {
      documents = isEmpty(documents) ? [res] : [res, ...documents];
    } else {
      documents = documents.filter((item) => item?.id !== res[0]?.id);
      documents?.unshift(res[0]);
    }
    currentInvestment.documents = documents;
    this.props.editRecord(this.props.investments, currentInvestment);
  };

  handleCreate = async (data, editData, reset) => {
    let res;

    let toSend = {
      ...data,
      opportunity: this.props.currentInvestment.id,
      document: data?.document?.data?.file?.data,
      is_published: data?.is_published === "Yes" ? "True" : "False",
    };

    if (!data?.document?.data?.file) {
      delete toSend?.document;
    }

    if (!editData?.id) {
      res = await ApiCallHandler.send(
        URLS.CREATE_OPPORTUNITIES_DOCUMENTS,
        "POST",
        toSend
      );
    } else {
      const dataToSend = {
        id: editData?.id,
        opportunity: this.props.currentInvestment.id,
        title: data.title,
      };
      res = await ApiCallHandler.send(
        URLS.UPDATE_OPPORTUNITIES_DOCUMENTS,
        "POST",
        dataToSend
      );
    }

    if (res && res.success) {
      this.updateReduxWithResponseData(editData?.id, res?.data);
      this.props.toggleToast({
        show: true,
        message: !editData?.id
          ? "Doc created successfully"
          : "Doc Updated Successfully",
        type: "success",
      });
      await this.props.editRecord(this.props.investments, res.data);
      this.props.close();
      reset();
    } else {
      this.props.close();
      this.props.toggleToast({
        showToast: true,
        message: "An error occurred. Try again",
        type: "failure",
      });
    }
  };

  getFieldValue = (field) => {
    let { doc } = this.props;
    let value = !doc?.id ? "" : this.state.currentData[field];
    return value;
  };

  render() {
    let { doc: editData } = this.props;
    let formRenderData = [
      {
        fieldType: Fields.INPUT,
        label: "Enter document title",
        name: "title",
        placeholder: "Eg. Partner Contract Agreement",
        required: true,
        value: editData?.id ? editData?.title : "",
      },
      {
        fieldType: Fields.RADIOGROUP,
        label: "Should this document be Public?",
        name: "is_published",
        data: ["Yes", "No"],
        required: true,
        value: editData?.id ? (editData?.is_published ? "Yes" : "No") : "",
      },
      {
        fieldType: Fields.FILE,
        label: "Document",
        name: "document",
        placeholder: "Upload Document",
        required: false,
        value: editData?.id ? editData?.document : "",
      },
    ];

    const displayFormArray = formRenderData;

    return (
      <div>
        <div id="form-container">
          <FormGenerator
            elevation={0}
            fields={displayFormArray}
            onSubmit={(data, reset) => this.handleCreate(data, editData, reset)}
            formSubmitBtnText={!editData?.id ? "Create" : "Save Changes"}
            subtitle=""
            title=""
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownerProps) => {
  const currentInvestment = state.investments.filter(x => x.id === ownerProps?.currentInvestment)[0]
  return {
    investments: state.investments,
    currentInvestment: currentInvestment,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleToast: toggleToastAction,
      editRecord: (current_data, new_data) => dispatch(editMutationAction("INVESTMENT", current_data, new_data)),
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateOpportunityDocument);
